// @ts-nocheck
import {ref, watch} from "vue";

export const useEnterFullscreen = () => {
    return () => {
        const doc = document.documentElement
        if (doc.requestFullscreen) {
            doc.requestFullscreen()
        } else if (doc.webkitRequestFullscreen) {
            doc.webkitRequestFullscreen()
        } else if (doc.msRequestFullscreen) {
            doc.msRequestFullscreen()
        }
    }
}

export const useExitFullscreen = () => {
    return () => {
        if (document.exitFullscreen) {
            document.exitFullscreen();
        } else if (document.webkitExitFullscreen) { /* Safari */
            document.webkitExitFullscreen();
        } else if (document.msExitFullscreen) { /* IE11 */
            document.msExitFullscreen();
        }
    }
}

export const useIsInFullscreen = () => {
    return () => {
        const enabled = ref<boolean>(false)
        document.onfullscreenchange = () => {
            enabled.value = !!document.fullscreenElement
        }
        return enabled
    }
}